(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/receivertype-info.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/receivertype-info.js');
"use strict";


const _svs$ui$reactForm = svs.ui.reactForm,
  RadioGroup = _svs$ui$reactForm.RadioGroup,
  RadioButton = _svs$ui$reactForm.RadioButton;
const _svs$tickets_giftshop = svs.tickets_giftshop.constants.names,
  PHONE = _svs$tickets_giftshop.PHONE,
  EMAIL = _svs$tickets_giftshop.EMAIL;
const _svs$tickets_giftshop2 = svs.tickets_giftshop.constants.form,
  PHONE_LABEL = _svs$tickets_giftshop2.PHONE_LABEL,
  EMAIL_LABEL = _svs$tickets_giftshop2.EMAIL_LABEL;
const _svs$ui$reactFormInpu = svs.ui.reactFormInputs,
  EmailInput = _svs$ui$reactFormInpu.EmailInput,
  MobileInput = _svs$ui$reactFormInpu.MobileInput;
const ReceiverTypeInfo = React.forwardRef((_ref, ref) => {
  let email = _ref.email,
    phone = _ref.phone,
    _ref$receiverType = _ref.receiverType,
    receiverType = _ref$receiverType === void 0 ? PHONE : _ref$receiverType,
    onInputChange = _ref.onInputChange,
    onReceiverTypeChange = _ref.onReceiverTypeChange;
  const isPhone = receiverType === PHONE;
  const isEmail = receiverType === EMAIL;
  const header = 'Hur vill du skicka lotterna?';
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "f-body"
  }, React.createElement("h2", {
    className: "tg-form-receiver-info-header h2 u-text-center margin-top-4 margin-bottom-3",
    ref: ref
  }, header), React.createElement("div", {
    className: "tg-receivertype-info gutter-sm-2"
  }, React.createElement("div", {
    className: "grid-row"
  }, React.createElement(RadioGroup, {
    className: "receiver-send-option-group col-sm-6 col-xs-12",
    size: "200"
  }, React.createElement(RadioButton, {
    checked: isPhone,
    onChange: onReceiverTypeChange,
    value: PHONE
  }, "Sms"), React.createElement(RadioButton, {
    checked: isEmail,
    onChange: onReceiverTypeChange,
    value: EMAIL
  }, "E-post")), React.createElement("div", {
    className: "col-sm-6 col-xs-12 data-hj-suppress"
  }, isPhone && React.createElement(MobileInput, {
    id: PHONE,
    label: PHONE_LABEL,
    name: PHONE,
    onChange: onInputChange,
    value: phone
  }), isEmail && React.createElement(EmailInput, {
    id: EMAIL,
    label: EMAIL_LABEL,
    name: EMAIL,
    onChange: onInputChange,
    value: email
  }))))));
});
svs.tickets_giftshop.gift.giftform.components.ReceiverTypeInfo = ReceiverTypeInfo;

 })(window);